import React from 'react'
import { Button, FormGroup, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { useInputValue } from '../../hooks/useInputValue'
import { Spell, SpellAssignment } from '../../redux/models'
import { useAppDispatch } from '../../redux/redux-hooks'
import { ModalsActions } from '../../redux/slices/modals-slice'
import { ViewTimelineActions } from '../../redux/slices/view-timeline-slice'
import { emptyStringAsUndefined, numberOrUndefined } from '../../util/utils'
import { LabeledInput } from './LabeledInput'

export const EDIT_ASSIGNMENT_MODAL = "EDIT_ASSIGNMENT_MODAL"

export type EditAssignmentModalProps = {
    spell: Spell
    spellAssignment: SpellAssignment
}

export const EditAssignmentModal = (props: EditAssignmentModalProps): JSX.Element | null => {

    const appDisp = useAppDispatch()

    const durationInputs = useInputValue({
        initialValue: props.spellAssignment.overrideDuration,
        options: { onBlur: emptyStringAsUndefined, allowOnlyNumbers: true }
    })

    const cooldownInputs = useInputValue({
        initialValue: props.spellAssignment.overrideCooldown,
        options: { onBlur: emptyStringAsUndefined, allowOnlyNumbers: true }
    })

    const rampInputs = useInputValue({
        initialValue: props.spellAssignment.overrideRamp,
        options: { onBlur: emptyStringAsUndefined, allowOnlyNumbers: true }
    })

    return (
        <Modal
            isOpen={true}
            size="md"
            fade={false}
            toggle={() => appDisp(ModalsActions.popModal())}
        >

            <ModalBody>

                <div className="d-flex flex-column space-my-2">
                    <h3>
                        {props.spell.name}
                    </h3>

                    <FormGroup className="flex-grow-1">
                        <LabeledInput
                            label={"Duration"}
                            inputProps={{
                                value: durationInputs.value ?? props.spell.duration,
                                onChange: durationInputs.onChange,
                                onBlur: durationInputs.onBlur
                            }}
                        />
                    </FormGroup>
                    <FormGroup className="flex-grow-1">
                        <LabeledInput
                            label={"Cooldown"}
                            inputProps={{
                                value: cooldownInputs.value ?? props.spell.cooldown,
                                onChange: cooldownInputs.onChange,
                                onBlur: cooldownInputs.onBlur
                            }}
                        />
                    </FormGroup>
                    <FormGroup className="flex-grow-1">
                        <LabeledInput
                            label={"Ramp"}
                            inputProps={{
                                value: rampInputs.value ?? props.spell.ramp,
                                onChange: rampInputs.onChange,
                                onBlur: rampInputs.onBlur
                            }}
                        />
                    </FormGroup>
                </div >

            </ModalBody>

            <ModalFooter className="d-flex justify-content-between">
                <Button onClick={() => {

                    appDisp(ViewTimelineActions.deleteAssignment({
                        assignmentId: props.spellAssignment.id
                    }))

                    appDisp(ModalsActions.popModal())

                }} color="danger">
                    {"Delete"}
                </Button>
                <div className="space-mx-2">
                    <Button onClick={() => {
                        // TODO: If saving something of 0 duration/cd, just delete it
                        appDisp(ViewTimelineActions.updateAssignmentOverrides({
                            spellAssignment: {
                                ...props.spellAssignment,
                                overrideCooldown: numberOrUndefined(cooldownInputs.value),
                                overrideDuration: numberOrUndefined(durationInputs.value),
                                overrideRamp: numberOrUndefined(rampInputs.value),
                            }
                        }))
                        appDisp(ModalsActions.popModal())
                    }}>
                        {"Save"}
                    </Button>

                    <Button onClick={() => appDisp(ModalsActions.popModal())}>
                        {"Cancel"}
                    </Button>
                </div>
            </ModalFooter>
        </Modal >
    )
}